import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';

export const NAV_BUTTON_SIZE: PlaneSize = {
  width: 156 + 18 + 10,
  height: 46,
};
